"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlanServiceRedirectionBindingNode = isPlanServiceRedirectionBindingNode;
function isPlanServiceRedirectionBindingNode(node) {
    return (node.redirections !==
        undefined);
}
//# sourceMappingURL=isPlanServiceRedirectionBindingNode.js.map